import { render } from "./DeliverablesListing.vue?vue&type=template&id=3e584875&scoped=true"
import script from "./DeliverablesListing.vue?vue&type=script&lang=js"
export * from "./DeliverablesListing.vue?vue&type=script&lang=js"

import "./DeliverablesListing.vue?vue&type=style&index=0&id=3e584875&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e584875"]])

export default __exports__